<div
  id="menu-container"
  *ngIf="itemDetailsStore.selectedItem$ | async as selectedItem"
  [class.has-image]="!!selectedItem.image.url"
>
  <v2-row
    id="header-container"
    justifyContent="space-between"
    alignItems="center"
    [class.opaque]="showOpaqueSheetHeader$ | async"
  >
    <v2-row alignItems="center">
      <v2-center
        id="close-cont"
        (click)="onBackButtonClick(selectedItem)"
        v2Ripple
      >
        <v2-icon
          icon="close-small"
          color="white"
          *ngIf="!hasParentSheet"
        ></v2-icon>
        <v2-icon
          icon="disclosure-left"
          color="white"
          *ngIf="hasParentSheet"
        ></v2-icon>
      </v2-center>
      <v2-body-header-3-text
        color="white"
        id="header-title"
        [class.visible]="showTitleInHeader"
        [lineClamp]="1"
      >
        {{ selectedItem.name }}
      </v2-body-header-3-text>
    </v2-row>

    <v2-item-badge
      *ngIf="selectedItem.badge.text"
      [item]="selectedItem"
      size="medium"
    ></v2-item-badge>
  </v2-row>

  <v2-column
    id="content-container"
    [class.loading-modifiers]="loadingItemModifiers$ | async"
  >
    <div
      id="backdrop-image"
      #backdropImageWrapper
      *ngIf="selectedItem.image.url"
      [style.background-image]="selectedItem.image.url | trust: 'style'"
      [class.tall-mode]="selectedItem.image.height > selectedItem.image.width"
      (click)="openLightbox()"
    >
      <v2-chip
        *ngIf="(orderMenuItemPinningStore.isPinningEnabled$ | async)"
        id="image-pin-button"
        class="pin-button"
        size="large"
        [color]="selectedItem.isPinned ? 'primary' : 'medium-grey'"
        (click)="togglePinMenuItem($event, selectedItem)"
      >
        <v2-label-secondary-text color="white">
          {{selectedItem.isPinned ? 'UN-' : ''}}PIN
        </v2-label-secondary-text>
        <v2-icon
          color="white"
          [icon]="selectedItem.isPinned ? 'unpin' : 'pin-outline'"
        ></v2-icon>
      </v2-chip>
    </div>

    <v2-card id="content-card" [boxShadow]="false" [flatBottom]="true">
      <div id="content-main-header">
        <v2-row justifyContent="space-between" alignItems="flex-start">
          <v2-body-header-0-text
            id="content-header-title"
            class="global-header-font"
            color="white"
            #contentHeaderTitle
          >
            {{ selectedItem.name }}
          </v2-body-header-0-text>
          <v2-body-header-0-text color="white">
            {{ selectedItem.price | v2Currency }}
          </v2-body-header-0-text>
        </v2-row>

        <v2-body-text
          id="content-header-desc"
          color="white"
          *ngIf="selectedItem.description"
        >
          {{ selectedItem.description }}
        </v2-body-text>

        <v2-item-tags-full
          [tags]="selectedItem.tags"
          *ngIf="selectedItem.tags.length > 0"
        ></v2-item-tags-full>

        <v2-row
          *ngIf="itemDetailsStore.itemDisabledChipText$ | async"
          id="content-item-disabled"
          justifyContent="flex-end"
        >
          <v2-chip>
            <v2-label-text color="white">
              {{itemDetailsStore.itemDisabledChipText$ | async}}
            </v2-label-text>
          </v2-chip>
        </v2-row>

        <v2-row
          *ngIf="(orderMenuItemPinningStore.isPinningEnabled$ | async) && !selectedItem.image.url"
          justifyContent="flex-end"
        >
          <v2-chip
            id="no-image-pin-button"
            class="pin-button"
            size="large"
            color="white"
            [outline]="!selectedItem.isPinned"
            (click)="togglePinMenuItem($event, selectedItem)"
          >
            <v2-label-secondary-text
              [color]="selectedItem.isPinned ? 'primary' : 'white'"
            >
              {{selectedItem.isPinned ? 'UN-' : ''}}PIN
            </v2-label-secondary-text>
            <v2-icon
              [color]="selectedItem.isPinned ? 'primary' : 'white'"
              [icon]="selectedItem.isPinned ? 'unpin' : 'pin-outline'"
            ></v2-icon>
          </v2-chip>
        </v2-row>
      </div>

      <v2-card
        id="modifiers-card"
        [boxShadow]="false"
        [flatBottom]="true"
        [class.recommended-card-space]="
          (recommendedItems$ | async)?.length! > 0
        "
      >
        <v2-row
          *ngIf="loadingItemModifiers$ | async"
          id="loading-modifiers-container"
          justifyContent="center"
        >
          <v2-progress-spinner [size]="30"></v2-progress-spinner>
        </v2-row>

        <ng-container *ngIf="!(loadingItemModifiers$ | async)">
          <v2-modifier-group
            *ngFor="
              let modifierGroup of itemDetailsStore.modifierGroupsForSelectedItem$
                | async;
              trackBy: modifierGroupService.stdGroupTrackByFn
            "
            [modifierGroup]="modifierGroup"
          ></v2-modifier-group>
        </ng-container>
      </v2-card>

      <!-- TODO: Extract the recommended items portion from review order page in a component and reuse it here -->
      <v2-card
        [boxShadow]="false"
        [flatBottom]="true"
        id="recommended-card"
        *ngIf="
          !(loadingItemModifiers$ | async) &&
          (recommendedItems$ | async)?.length! > 0
        "
      >
        <div>
          <v2-column justifyContent="center" class="header-text-container">
            <v2-label-text color="dark-grey" textAlign="center">
              {{ (itemRecommendationHeaderText$ | async) || '' | uppercase }}
            </v2-label-text>
            <v2-body-text
              color="dark-grey"
              textAlign="center"
              class="secondary-text"
              *ngIf="
                itemRecommendationSecondaryText$
                  | async as itemRecommendationSecondaryText
              "
            >
              {{ itemRecommendationSecondaryText }}
            </v2-body-text>
          </v2-column>

          <v2-card
            class="item-recommendation-card"
            *ngFor="
              let item of recommendedItems$ | async;
              trackBy: uiService.stdEntityIdTrackByFn
            "
            (click)="onItemRecommendationClick(item)"
          >
            <v2-row
              class="item-recommendation-container"
              justifyContent="space-between"
              alignItems="center"
            >
              <v2-row alignItems="center" class="item-rec-left">
                <div>
                  <v2-body-header-3-text color="black">
                    {{ item.name }}
                  </v2-body-header-3-text>
                  <v2-body-text color="dark-grey" class="middle-text">
                    Pairs well with {{ selectedItem.name }}
                  </v2-body-text>
                  <v2-body-small-text color="black" class="bottom-text">
                    {{ item.price | v2Currency }}
                  </v2-body-small-text>
                </div>
              </v2-row>

              <div
                *ngIf="item.image.thumbnailUrl"
                [style.background-image]="
                  item.image.thumbnailUrl | trust: 'style'
                "
                class="item-rec-image"
              ></div>
            </v2-row>
          </v2-card>
        </div>
      </v2-card>
    </v2-card>
  </v2-column>
</div>
